module.exports = __webpack_public_path__ + "img/entityEle.2a0586da.svg";